import { trimToUndefined } from "@Front/Utils/formatters";

export interface FolderSharingPayload {
	invitedNotaryEmail: string;
	invitedNotaryCrpcen?: string;
	can_view_other_members_documents?: boolean;
	invitedNotaryIdnot?: string;
	invitedNotaryOfficeIdNot?: string;
	invitedNotaryFirstName?: string;
	invitedNotaryLastName?: string;
	invitedNotaryContactUid?: string;
}

export interface InvitedNotaryEmailPayload {
	invited_notary_email: string;
	invited_notary_idnot?: string;
}

type FolderSharingInviteOptionals = Pick<
	FolderSharingPayload,
	"invitedNotaryIdnot" | "invitedNotaryOfficeIdNot" | "invitedNotaryFirstName" | "invitedNotaryLastName" | "invitedNotaryContactUid"
>;

function assignInvitedNotaryOptionalFieldsToFolderSharingPayload(
	payload: FolderSharingPayload,
	params: {
		invitedNotaryIdnot?: string;
		invitedNotaryOfficeIdNot?: string;
		invitedNotaryFirstName?: string;
		invitedNotaryLastName?: string;
		invitedNotaryContactUid?: string;
	},
): void {
	const assigned: FolderSharingInviteOptionals = {};
	const invitedNotaryIdnot = trimToUndefined(params.invitedNotaryIdnot);
	if (invitedNotaryIdnot) {
		assigned.invitedNotaryIdnot = invitedNotaryIdnot;
	}
	const invitedNotaryOfficeIdNot = trimToUndefined(params.invitedNotaryOfficeIdNot);
	if (invitedNotaryOfficeIdNot) {
		assigned.invitedNotaryOfficeIdNot = invitedNotaryOfficeIdNot;
	}
	const invitedNotaryFirstName = trimToUndefined(params.invitedNotaryFirstName);
	if (invitedNotaryFirstName) {
		assigned.invitedNotaryFirstName = invitedNotaryFirstName;
	}
	const invitedNotaryLastName = trimToUndefined(params.invitedNotaryLastName);
	if (invitedNotaryLastName) {
		assigned.invitedNotaryLastName = invitedNotaryLastName;
	}
	const invitedNotaryContactUid = trimToUndefined(params.invitedNotaryContactUid);
	if (invitedNotaryContactUid) {
		assigned.invitedNotaryContactUid = invitedNotaryContactUid;
	}
	Object.assign(payload, assigned);
}

export function buildFolderSharingPayload(params: {
	invitedNotaryEmail: string;
	invitedNotaryCrpcen?: string;
	canViewOtherMembersDocuments?: boolean;
	invitedNotaryIdnot?: string;
	invitedNotaryOfficeIdNot?: string;
	invitedNotaryFirstName?: string;
	invitedNotaryLastName?: string;
	invitedNotaryContactUid?: string;
}): FolderSharingPayload {
	const payload: FolderSharingPayload = {
		invitedNotaryEmail: params.invitedNotaryEmail,
	};

	if (params.invitedNotaryCrpcen) {
		payload.invitedNotaryCrpcen = params.invitedNotaryCrpcen;
	}

	if (typeof params.canViewOtherMembersDocuments === "boolean") {
		payload.can_view_other_members_documents = params.canViewOtherMembersDocuments;
	}

	assignInvitedNotaryOptionalFieldsToFolderSharingPayload(payload, params);

	return payload;
}

export function buildInvitedNotaryEmailPayload(
	invitedNotaryEmail: string,
	invitedNotaryIdnot?: string,
): InvitedNotaryEmailPayload {
	const payload: InvitedNotaryEmailPayload = { invited_notary_email: invitedNotaryEmail };
	const trimmedIdNot = trimToUndefined(invitedNotaryIdnot);
	if (trimmedIdNot) {
		payload.invited_notary_idnot = trimmedIdNot;
	}
	return payload;
}
